<template>
    <section>
        <b-table
            :loading="isLoading"
            :data="data"
            :striped="true"
            :narrowed="false"
            :hoverable="true"
            :paginated="true"
            :per-page="10">

            <template slot-scope="props">
              <b-table-column label="Fecha">
                    {{$moment(props.row.date, 'YYYY-MM-DD').format('DD MMMM YYYY')}}
                </b-table-column>
                <b-table-column field="name" label="Nombre">
                    {{ props.row.name }}
                </b-table-column>

                <b-table-column field="last_name" label="Tipo" centered>
                    {{ props.row.type ? props.row.type.name : '' }}
                </b-table-column>
                <b-table-column custom-key="actions" class="is-actions-cell">
                  <div class="buttons is-right">
                    <b-button type="is-info" size="is-small" @click="$emit('edit', props.row)">
                      <b-icon icon="pencil" size="is-small"></b-icon>
                    </b-button>
                    <b-button :loading="isLoadingDelete && indexSelected === props.index" type="is-danger" size="is-small" @click="confirmDelete(props.row, props.index)">
                      <b-icon icon="close" size="is-small"></b-icon>
                    </b-button>
                  </div>
                </b-table-column>
            </template>

            <template slot="empty">
                <section class="section" slot="empty">
                  <div class="content has-text-grey has-text-centered">
                    <template v-if="isLoading">
                      <p>
                        <b-icon icon="dots-horizontal" size="is-large" />
                      </p>
                      <p>Cargando Registros...</p>
                    </template>
                    <template v-else>
                      <p>
                        <b-icon icon="horseshoe" size="is-large" />
                      </p>
                      <p>No hay registros&hellip;</p>
                    </template>
                  </div>
                </section>
            </template>
        </b-table>
    </section>
</template>

<script>
import OffDayService from '@/services/OffDayService'

export default {
  props: {
    data: {
      required: false,
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      indexSelected: null,
      isLoadingDelete: false
    }
  },
  created () {
  },
  methods: {
    confirmDelete (data, index) {
      this.indexSelected = index
      let date = this.$moment(data.date, 'YYYY-MM-DD').format('DD MMMM')
      this.$buefy.dialog.confirm({
        title: 'Eliminar Día',
        message: `¿Seguro que desea <b>quitar</b> el día bloqueado? Esta acción no se puede deshacer. <br> Día <b>${date}</b> <b>${data.name}</b>`,
        confirmText: 'Quitar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.delete(data)
      })
    },
    async delete (data) {
      this.isLoadingDelete = true
      let offDayId = data.id
      try {
        let response = await OffDayService.deleteOffDays(offDayId)
        this.isLoadingDelete = false
        if (response && response.status === 200) {
          this.alertMessage('Se ha desvinculado caballo correctamente', 'is-success')
          this.$emit('deleted')
        } else {
          this.alertMessage(`Ha ocurrido un error no se pudo completar`, 'is-danger')
        }
      } catch (error) {
        console.log(error)
        this.alertMessage(`Ha ocurrido un error no se pudo completar`, 'is-danger')
      }
    },
    alertMessage (message, type) {
      this.$buefy.toast.open({
        message: message,
        type: type
      })
    }
  },
  watch: {
  }
}
</script>

<style>
  .capitalize-text{
    text-transform: capitalize;
  }
</style>
